import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";

import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface Request {
    customer_idx: number;
    customer_name: string;
}

interface Response {
    data: {
        customer_idx: number;
    };
}

export const usePutCustomer = (successCallback?: () => void): UseMutationResult<Response, Error, Request, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);
    const auth = useAuthStore(state => state);
    const setAuth = useAuthStore(state => state.setAuth);

    return useMutation<Response, Error, Request>({
        mutationFn: async ({ customer_idx, customer_name }: Request) => {
            const response = await axios.put(
                enum_api_uri.user.put_customer,
                {
                    customer_idx,
                    customer_name,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data;
        },
        onSuccess: data => {
            successCallback?.();

            setAuth({
                ...auth,
                customer_idx: data.data.customer_idx,
            });

            queryClient.invalidateQueries({ queryKey: ["getCustomer"] });
        },
        // onError: (error: Error) => {
        //     console.error("로그인 실패:", error);
        // },
        // isError로 수정해보기
    });
};
